import React from 'react';
import { Navigate } from 'react-router-dom';
import { Page, Banner } from '@shopify/polaris';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
  fallbackMessage?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  allowedRoles, 
  fallbackMessage = "Access denied. You don't have permission to view this page." 
}) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return (
      <Page>
        <Banner tone="critical">
          {fallbackMessage}
        </Banner>
      </Page>
    );
  }
  
  return <>{children}</>;
};

export default ProtectedRoute;
